import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const ExternalRight24 = (props: SvgIconProps): JSX.Element => React.createElement(
    SvgIcon,
    props,
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <path fillRule='evenodd' clipRule='evenodd' d='M20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L13.7071 19.7071C13.3166 20.0976 12.6834 20.0976 12.2929 19.7071C11.9024 19.3166 11.9024 18.6834 12.2929 18.2929L17.5858 13L4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11L17.5858 11L12.2929 5.70711C11.9024 5.31658 11.9024 4.68342 12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289L20.7071 11.2929Z' fill='currentColor' />
    </svg>,
);
